export default {"src":"/_next/static/media/travel.a14b3b58.svg","height":710,"width":1134,"blurWidth":0,"blurHeight":0};